import ManagerClientInfo from './ManagerClientInfo';

export default ManagerClientInfo;
